import { IMForm, IMZipCountyField, IMZipCodeField, IMZipStateField } from '@insurancemenu/imenu-components-lib';
import { breakpointsMQ4 } from '@insurancemenu/imenu-components-lib/dist/utils';
import styled, { css } from 'styled-components';

export const IMFormStyled = styled(IMForm)`
  max-width: none;
  padding: 0;
`;

const zipFieldResponsiveStyles = css`
  ${breakpointsMQ4.xl.down} {
    flex-basis: 30%;
  }
  ${breakpointsMQ4.md.down} {
    flex-basis: 100%;
  }
`;

export const IMZipCodeFieldStyled = styled(IMZipCodeField)`
  ${zipFieldResponsiveStyles}
`;

export const IMZipStateFieldStyled = styled(IMZipStateField)`
  ${zipFieldResponsiveStyles}
`;

export const IMZipCountyFieldStyled = styled(IMZipCountyField)`
  ${zipFieldResponsiveStyles}
`;
